
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATION  = 'FETCH_NOTIFICATION';
export const FETCH_NOTIFICATION_SUCCESS = 'FETCH_NOTIFICATION_SUCCESS';
export const READ_NOTIFICATION  = 'READ_NOTIFICATION';
export const READ_NOTIFICATION_SUCCESS = 'READ_NOTIFICATION_SUCCESS';
export const UNREAD_NOTIFICATION  = 'UNREAD_NOTIFICATION';
export const UNREAD_NOTIFICATION_SUCCESS = 'UNREAD_NOTIFICATION_SUCCESS';
export const DELETE_NOTIFICATION  = 'DELETE_NOTIFICATION';
export const DELETE_NOTIFICATION_SUCCESS = 'DELETE_NOTIFICATION_SUCCESS';


// WEBPACK FOOTER //
// ./src/data/notifications/types.js